import * as angular from 'angular';
import { FeatureTogglesResource } from 'angular/resources/feature-toggles.resource';
import { config } from 'angular/utils/config';

class StorageLocationDetailsViewCtrl implements ng.IController {
    public storageLocation: StorageLocationDto;
    public isEditMode: boolean;
    public isCreateMode: boolean;
    public loggedInUser: LoginResult;
    public stageConfig = config;

    public featureFlags = {
        storageLocationCreationAndUpdate: false
    };

    constructor(
        private $window,
        private featureTogglesResource: FeatureTogglesResource
    ) {}

    $onInit() {
        this.featureTogglesResource.getUrls().subscribe(({ flags }) => {
            this.featureFlags.storageLocationCreationAndUpdate =
                !!flags.storageLocationCreationAndUpdate;
        });
    }

    public goBack(): void {
        this.$window.history.back();
    }
}

angular.module('app').component('pkpStorageLocationDetailsView', {
    controller: StorageLocationDetailsViewCtrl,
    template:
        require('app/storage-location/storage-location-details-view.component.html'),
    bindings: {
        form: '=',
        loggedInUser: '<',
        storageLocationId: '<',
        storageLocation: '=',
        isEditMode: '<?',
        isCreateMode: '<?'
    }
});
